/* eslint-disable */
import axios from "axios";
import config from "@assets/config.json"; // api 请求json
// 通用 Module
const state = {};
const mutations = {};
const getters = {};
const actions = {
  getKindByExhibitionList({ rootState }, id) {
    // 根据展会Id获取产品类别
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/kind/GetAndListByExhibition?exhibitionId=${id}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  putKind({ rootState }, opt) {
    // 修改产品类别（Kind）
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/kind`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  putKindCategory({ rootState }, opt) {
    // 修改产品类别（Kind）
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/kind/category`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  delKind({ rootState }, id) {
    // 删除产品类别（Kind）
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/kind?id=${id}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },

  addKind({ rootState }, opt) {
    // 增加产品类别
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/kind`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },

  getCategoryByExhibitionList({ rootState }, id) {
    // 根据展会Id获取产品类别
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/category/GetAndListByExhibition?exhibitionId=${id}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  getProductByGroupId({ rootState }, opt) {
    let isNumber = typeof opt.level === "number" && !isNaN(opt.level); 
    // 通过groupId获取产品类别
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/Category/ByGroupId?groupId=${opt.groupId}${isNumber ? "&level=" + opt.level : ""}${opt.loadChild ? "&loadChild=true" : ""}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  getProductByParentId({ rootState }, parentId) {
    // 通过groupId获取产品类别
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/Category/GetByParentId?parentId=${parentId}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
  putCategory({ rootState }, opt) {
    // 修改产品类别（Category）
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/category`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  delCategory({ rootState }, id) {
    // 删除产品类别（Category）
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/category?id=${id}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },

  addCategory({ rootState }, opt) {
    // 增加产品类别
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/category`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },

  addExPlan({ rootState }, opt) {
    // 增加展会计划
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ExhibitionPlan`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  putExPlan({ rootState }, opt) {
    // 修改展会计划
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/ExhibitionPlan`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  delExPlan({ rootState }, id) {
    // 删除展会计划
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/ExhibitionPlan?id=${id}`, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err.response.data);
        });
    });
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
